<template>

    <CRow>
        <CCol>
            <CCard class="store-card">
                <CCardHeader>
                    <strong>{{ entity.title }}</strong>
                </CCardHeader>
                <CCardBody>
                    <EntitySettingsTabLinks />
                    <CRow class="pl-3 pb-3" />
                    
                    <CRow class="pl-3 pb-3" />
                    <CRow form class="form-group">
                        <CCol sm="3" class="col-form-label">Название</CCol>
                        <CCol sm="9" class="col-form-label">{{ entity.title }}</CCol>
                    </CRow>
                    <CRow form class="form-group">
                        <CCol sm="3" class="col-form-label">Подпись для главной</CCol>
                        <CCol
                            sm="9"
                            class="col-form-label"
                            v-html="entity.title_formatted" />
                    </CRow>
                    <CRow form class="form-group">
                        <CCol sm="3" class="col-form-label">Код</CCol>
                        <CCol sm="9" class="col-form-label">{{ entity.code }}</CCol>
                    </CRow>
                    <CRow form class="form-group">
                        <CCol sm="3" class="col-form-label">Цвет</CCol>
                        <CCol sm="9" class="col-form-label">{{ entity.color }}</CCol>
                    </CRow>
                    <CRow form class="form-group">
                        <CCol sm="3" class="col-form-label">Градиент</CCol>
                        <CCol sm="9" class="col-form-label">{{ entity.gradient }}</CCol>
                    </CRow>
                    <CRow form class="form-group">
                        <CCol sm="3" class="col-form-label">Иконка</CCol>
                        <CCol sm="9" class="col-form-label">{{ entity.icon }}</CCol>
                    </CRow>
                    <CRow form class="form-group">
                        <CCol sm="3" class="col-form-label">Картинка приложения</CCol>
                        <CCol sm="9" class="col-form-label">
                            <CImg
                                :src="pictureUrl"
                                class="m2"
                                width="300" />
                        </CCol>
                    </CRow>
                    <CRow
                        v-if="largePictureUrl"
                        form
                        class="form-group">
                        <CCol sm="3" class="col-form-label">Картинка сайта</CCol>
                        <CCol sm="9" class="col-form-label">
                            <CImg
                                :src="largePictureUrl"
                                class="m2"
                                width="300" />
                        </CCol>
                    </CRow>
                    <CRow
                        v-if="pictureMainPageUrl"
                        form
                        class="form-group">
                        <CCol sm="3" class="col-form-label">Картинка для главной (большая)</CCol>
                        <CCol sm="9" class="col-form-label">
                            <CImg
                                :src="pictureMainPageUrl"
                                class="m2"
                                width="300" />
                        </CCol>
                    </CRow>
                    <CRow
                        v-if="pictureMainPageSqUrl"
                        form
                        class="form-group">
                        <CCol sm="3" class="col-form-label">Картинка для главной (маленькая)</CCol>
                        <CCol sm="9" class="col-form-label">
                            <CImg
                                :src="pictureMainPageSqUrl"
                                class="m2"
                                width="300" />
                        </CCol>
                    </CRow>
                    <CRow
                        v-if="largePictureUrl"
                        form
                        class="form-group">
                        <CCol sm="3" class="col-form-label">Данные для аналитики
                            <CBadge :color="entity.analytics_data ? 'success' : 'secondary'">
                                {{ entity.analytics_data ? "Да" : "Нет" }}
                            </CBadge></CCol>
                        <CCol sm="9" class="col-form-label">
                            <template v-for="item in entity.analytics_data_values">
                                <div :key="`analytics_data_value-${item.id}`">{{ item.title }}</div>
                            </template>
                        </CCol>
                    </CRow>
                    <CRow
                        v-if="largePictureUrl"
                        form
                        class="form-group">
                        <CCol sm="3" class="col-form-label">Активен</CCol>
                        <CCol sm="9" class="col-form-label">
                            <CBadge :color="entity.enabled ? 'success' : 'secondary'">
                                {{ entity.enabled ? "Да" : "Нет" }}
                            </CBadge>
                        </CCol>
                    </CRow>
                </CCardBody>
                <CCardFooter>
                    <CButton
                        color="primary"
                        class="mr-3"
                        @click="goBack">Назад</CButton>
                </CCardFooter>
            </CCard>
        </CCol>

    </CRow>
</template>

<script>
    import Vue from 'vue';
    import EntitySettingsTabLinks from '@/components/entities/EntitySettingsTabLinks';

    export default {

        name: 'EntityTypeSettings',

        components: {
            EntitySettingsTabLinks,
        },
  
        data () {
            return {
                entity: {
                    title: '',
                    code: '',
                    color: '',
                    gradient: '',
                    picture: '',
                    large_picture: '',
                    picture_main_page: '',
                    picture_main_page_sq: '',
                    icon: '',
                    enabled: true,
                },
            }
        },
    
        computed: {
            pictureUrl() {
                if(this.entity.picture) {
                    return process.env.VUE_APP_STATIC_BASE_URL + '/' + this.entity.picture;
                } else {
                    return '';
                }
            },
            largePictureUrl() {
                if(this.entity.large_picture) {
                    return process.env.VUE_APP_STATIC_BASE_URL + '/' + this.entity.large_picture;
                } else {
                    return '';
                }
            },
            pictureMainPageUrl() {
                if(this.entity.picture_main_page) {
                    return process.env.VUE_APP_STATIC_BASE_URL + '/' + this.entity.picture_main_page;
                } else {
                    return '';
                }
            },
            pictureMainPageSqUrl() {
                if(this.entity.picture_main_page_sq) {
                    return process.env.VUE_APP_STATIC_BASE_URL + '/' + this.entity.picture_main_page_sq;
                } else {
                    return '';
                }
            }
        },

        mounted() {
            const id = this.$route.params.id;
            Vue.axios.get('/entities-type/' + id)
                .then(resp => {
                    this.entity = resp.data;
                })
                .catch(() => {
                    this.$root.$emit('showError', 'Ошибка загрузки данных.');
                });
        },
        methods: {
            goBack() {
                this.$router.push({ path: '/settings/entities' })
            },
            getBadge (status) {
                return status ? 'success' : 'secondary';
            },
        }
    }
</script>
